import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18TimeB = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M9 2a7 7 0 1 1 0 14A7 7 0 0 1 9 2m0 1.19a5.81 5.81 0 1 0 0 11.62A5.81 5.81 0 0 0 9 3.19M8.87 4.8c.312 0 .565.254.565.567l-.002 3.197 3.202.004.077.005a.566.566 0 0 1-.078 1.127l-3.769-.004-.077-.005A.566.566 0 0 1 8.3 9.13l.004-3.764.005-.077a.566.566 0 0 1 .56-.489"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18TimeB$1 = Svg18TimeB;

export { Svg18TimeB$1 as default };
